import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner } from 'react-bootstrap';
import { fetchForPagination } from '@lib/api';
import TablePagination from '@mui/material/TablePagination';
import Pagination from '@mui/material/Pagination';

const CustomPaginationMui = ({
	dataMeta,
	setData,
	setDataMeta,
	rowsPerPageOptions = [100, 200, 500],
	rowsPerPageDefault = undefined,
	refTable,
	setIsFirstResearch,
	setIsChangedPagination,
	labelRowsPerPage = 'record per pagina:',
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageDefault ?? dataMeta?.meta?.perPage);
	let infoRowsPerTable = localStorage.getItem('rowsPerTable');
	//console.log('dataMeta?.meta?.perPage:', refTable, dataMeta?.meta?.perPage);

	useEffect(() => {
		//let infoRowsPerTable = localStorage.getItem('rowsPerTable');
		let localStorageRowsPerTable = infoRowsPerTable ? JSON.parse(infoRowsPerTable) : infoRowsPerTable;

		if (Array.isArray(localStorageRowsPerTable) && localStorageRowsPerTable.some((el) => el.refTable === refTable)) {
			//se c'è la ref
			setRowsPerPage(
				Number(
					localStorageRowsPerTable
						.filter((el) => el.refTable === refTable)
						.map((el) => el.perPage)
						.join(),
				),
			);
		}
	}, [infoRowsPerTable, refTable]);

	const handleChangePage = async (event, newPage, setList, listMeta, setListMeta) => {
		setIsLoading(true);
		if (setIsChangedPagination) setIsChangedPagination(false);

		let url = listMeta.meta.links
			.filter((el) => Number(el.label) === newPage + 1)
			.map((el) => el.url)
			.pop();

		// Aggiungi perPage se rowsPerPageDefault è valorizzato
		if (rowsPerPageDefault) {
			const urlObj = new URL(url, window.location.origin);
			urlObj.searchParams.set('perPage', rowsPerPageDefault);
			url = urlObj.toString();
		}

		const resp = await fetchForPagination(url);

		if (resp.success) {
			setList(resp.data);

			const { data, success, ...restResp } = resp;
			setListMeta(restResp);
			if (setIsChangedPagination) setIsChangedPagination(true);
		}

		setIsLoading(false);
	};

	const handleChangeRowsPerPage = async (event, setList, listMeta, setListMeta) => {
		setIsLoading(true);
		if (setIsChangedPagination) setIsChangedPagination(false);

		let url = new URL(listMeta.links.first);
		let searchParams = url.searchParams;

		// set new value of "id"
		searchParams.set('perPage', event.target.value);

		// change the search property of the main url
		url.search = searchParams.toString();

		const newUrl = url.toString();
		//console.log('newUrl', newUrl);

		const resp = await fetchForPagination(newUrl);

		setList(resp.data);

		const { data, success, ...restResp } = resp;
		setListMeta(restResp);
		if (setIsChangedPagination) setIsChangedPagination(true);

		let infoRowsPerTable = localStorage.getItem('rowsPerTable');
		infoRowsPerTable = infoRowsPerTable ? JSON.parse(infoRowsPerTable) : infoRowsPerTable;

		if (Array.isArray(infoRowsPerTable) && infoRowsPerTable.some((el) => el.refTable === refTable)) {
			//se c'è già la ref
			const indexOfArray = infoRowsPerTable.findIndex((el) => el.refTable === refTable);
			infoRowsPerTable[indexOfArray].perPage = event.target.value;

			//disabled
			/* localStorage.setItem('rowsPerTable', JSON.stringify(infoRowsPerTable)); */
		} else {
			if (!Array.isArray(infoRowsPerTable)) {
				infoRowsPerTable = [];
			}
			infoRowsPerTable.push({ refTable: refTable, perPage: event.target.value });

			//disabled
			/* localStorage.setItem('rowsPerTable', JSON.stringify(infoRowsPerTable)); */
		}

		setRowsPerPage(event.target.value);
		if (setIsFirstResearch) setIsFirstResearch(true);
		setIsLoading(false);
	};

	if (!dataMeta?.meta) return null;

	const CustomTablePaginationActions = (props) => {
		const { count, page, rowsPerPage, onPageChange } = props;
		const totalPages = Math.ceil(count / rowsPerPage);

		if (totalPages <= 1) return null;

		return (
			<Pagination
				count={totalPages} // total number of pages
				page={page + 1}
				onChange={(e, value) => onPageChange(e, value - 1)}
				showFirstButton
				showLastButton
				classes={{ ul: 'custom-pagination-ul' }}
				siblingCount={1}
				boundaryCount={1}
			/>
		);
	};

	return (
		<Row className="flex-row justify-content-center align-items-center" style={{ marginTop: '0.75rem' }}>
			<Col className="col-auto p-0">{isLoading && <Spinner animation="border" role="status" variant="dark" size="sm" />}</Col>
			<Col className="col-auto d-flex">
				<TablePagination
					component="div"
					rowsPerPageOptions={Array.from(new Set(rowsPerPageOptions.concat([Number(rowsPerPage)]))).sort((a, b) => a - b)}
					count={dataMeta?.meta?.total} // total items
					page={dataMeta?.meta?.currentPage - 1}
					rowsPerPage={rowsPerPage}
					onPageChange={(e, newPage) => handleChangePage(e, newPage, setData, dataMeta, setDataMeta)}
					onRowsPerPageChange={(e) => handleChangeRowsPerPage(e, setData, dataMeta, setDataMeta)}
					labelRowsPerPage={labelRowsPerPage}
					labelDisplayedRows={({ count }) => `${count} totali`}
					showFirstButton
					showLastButton
					ActionsComponent={CustomTablePaginationActions}
				/>
			</Col>
		</Row>
	);
};
export default CustomPaginationMui;
